// Our main CSS
import '../css/app.css'

/**
 * Vue is ready for you, if you need it.
 */

/**
 * The following block of code automatically registers your Vue components.
 * It will recursively scan this directory for the Vue components and
 * automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 *
 * Feel free to remove this block if you don't like black magic fuckery,
 * or you want to register your Vue components manually.
 */
/*
 *** https://v3.vuejs.org/
 */
// interface ImportedModule {
//   name: string
//   default: object
// }
// const vueSingleFileComponents = import.meta.glob<ImportedModule>('./**/*.vue', {
//   eager: true
// })

// import { createApp } from 'vue'
// const app = createApp({})

// for (const path in vueSingleFileComponents) {
//   const importedModule = vueSingleFileComponents[String(path)]
//   const name = path.split('/').pop()?.split('.')[0]
//   if (name !== undefined && typeof name === 'string') {
//     app.component(name, importedModule.default)
//   }
// }
// app.mount('#vue-app')

/**
OR:

Load a js-module dynamically, if the parent element exists, in this example, a vue component. (The js-file wont load if html element with id #ExampleVueComponentWrapper does not exists)
*/

/**
const ExampleVueComponentWrapper = document.getElementById(
  'ExampleVueComponentWrapper'
)
if (ExampleVueComponentWrapper && ExampleVueComponentWrapper !== null) {
  import('./ExampleVueComponent/index.js')
    .then((module) => {
      module.default(ExampleVueComponentWrapper as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}
*/

/**
 * 🦄: Now do your magic.
 */
const membershipSlider = document.querySelectorAll('.membership-slider')

if (membershipSlider.length) {
  import('./modules/membershipSlider').then((module) => {
    module.default()
  })
}

const quoteSlider = document.querySelectorAll('.quote-slider')

if (quoteSlider.length) {
  import('./modules/quoteSlider').then((module) => {
    module.default()
  })
}

const lottieText = document.getElementById('lottie-text')

if (lottieText) {
  import('./modules/lottieText').then((module) => {
    module.default()
  })
}

document.addEventListener('DOMContentLoaded', () => {
  let lastScrollTop = 0;
  const pageMenu = document.querySelector('.page-menu');
  const menuToggles = document.querySelectorAll('.menu-toggle');
  const overlayMenu = document.querySelector('.overlay-menu');
  const menuLinks = document.querySelectorAll('.overlay-menu a');  // Select all the links in the menu

  // Handler for scroll events
  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop < 100) {
      pageMenu.classList.remove('hide');
    } else if (scrollTop > lastScrollTop) {
      pageMenu.classList.add('hide');
      pageMenu.classList.remove('show');
    } else {
      pageMenu.classList.remove('hide');
      pageMenu.classList.add('show');
    }
    if (scrollTop > 500) {
      pageMenu.classList.add('has-scrolled');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  };

  // Handler for menu toggle clicks
  const toggleOverlayMenu = () => {
    overlayMenu.classList.toggle('visible');
    const isVisible = overlayMenu.classList.contains('visible');

    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  // Close the menu when a link is clicked
  const closeMenuOnLinkClick = () => {
    overlayMenu.classList.remove('visible');
    document.body.style.overflow = '';  // Reset body overflow
  };

  // Add event listeners
  window.addEventListener('scroll', handleScroll);

  menuToggles.forEach((toggle) => {
    toggle.addEventListener('click', toggleOverlayMenu);
  });

  // Add click event to each link in the overlay menu
  menuLinks.forEach((link) => {
    link.addEventListener('click', closeMenuOnLinkClick);
  });

  // Optional: Cleanup event listeners when the page is unloaded
  window.addEventListener('beforeunload', () => {
    window.removeEventListener('scroll', handleScroll);
    menuToggles.forEach((toggle) => {
      toggle.removeEventListener('click', toggleOverlayMenu);
    });
    menuLinks.forEach((link) => {
      link.removeEventListener('click', closeMenuOnLinkClick);
    });
  });
});
